import { prefixLink } from '@ms/config/app'
import { tryJumpAppPage, gotoAppHome, gotoAppVoucher, gotoAppSportList, gotoAppMatchDetail, gotoAppDeposit, gotoAppTransaction, gotoAppTransactionDetails } from 'wap/hybrid'
import { isApp } from 'wap/hybrid/device.js'
import { getMatchDetailLink } from '@ms/routes/match'

export const openPage = (pageUrl = '', appScheme = '') => {
  if (isApp() && appScheme) {
    tryJumpAppPage(appScheme)
  } else {
    location.href = pageUrl
  }
}

// 打开充值页, 带参数
export const openRecharge = (params = '', appParams = '') => {
  if (isApp()) {
    gotoAppDeposit(appParams)
  } else {
    location.href = prefixLink('/recharge') + params
  }
}

export const gotoRecharge = () => {
  if (isApp()) {
    gotoAppDeposit()
  } else {
    location.href = prefixLink('/recharge')
  }
}

export const goHome = () => {
  if (isApp()) {
    gotoAppHome()
  } else {
    location.href = prefixLink() + location.search
  }
}

export const gotoTrades = () => {
  if (isApp()) {
    gotoAppTransaction()
  } else {
    location.href = prefixLink('/trades')
  }
}

export const gotoTradeDetail = (tradeId = '') => {
  if (isApp()) {
    gotoAppTransactionDetails(tradeId)
  } else {
    location.href = prefixLink(`/trades/details/${tradeId}`)
  }
}

export const gotoVouchers = () => {
  if (isApp()) {
    gotoAppVoucher()
  } else {
    location.href = prefixLink('/vouchers')
  }
}

export const gotoBetting = () => {
  if (isApp()) {
    gotoAppSportList({ filterTime: 'Next%203%20Days' })
  } else {
    location.href = prefixLink('/sports/list/soccer?d=Next%203%20Days')
  }
}

export const gotoBettingToday = () => {
  if (isApp()) {
    gotoAppSportList({ filterTime: 'Today' })
  } else {
    location.href = prefixLink(`/sports/list/Soccer/matches_on_today${location.search}`)
  }
}

export const gotoMatchDetail = (event = {}, callbackWap = null) => {
  if (isApp()) {
    gotoAppMatchDetail({ eventId: event.eventId, sportId: event.sportId })
  } else {
    callbackWap && callbackWap()
    location.href = getMatchDetailLink(event, 'href')
  }
}
